import cn from 'clsx'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

import Clickable from 'components/Common/Clickable/Clickable'
import { SvgIconComponent } from 'components/Luxkit/SvgIcon'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Group from 'components/utils/Group'

const Root = styled(Clickable)`
  padding: ${rem(12)};
  border-radius: ${({ theme }) => theme.borderRadius.M};
  text-align: center;
  flex-shrink: 0;

  &:hover {
    background-color: ${({ theme }) => theme.palette.neutral.seven};
  }

  &.selected {
    background-color: ${({ theme }) => theme.palette.neutral.six};

    &:hover {
      background-color: ${({ theme }) => theme.palette.neutral.seven};
    }
  }
`

// Render the icon and text invisibly to reserve the correct width
const PlaceHolderGroup = styled(Group)`
  visibility: hidden;
  user-select: none;
`

const LabelWrapper = styled.div`
  position: relative;
`

const AbsoluteBlock = styled(Group)`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`
interface Props {
  iconComponent: SvgIconComponent
  label: string
  count: number
  selected: boolean
  onClick: () => void
  // eslint-disable-next-line @typescript-eslint/naming-convention
  'data-testid'?: string
}

function TripItemFilter(props: Props) {
  const {
    iconComponent: Icon,
    label,
    count,
    selected,
    onClick,
    'data-testid': testId,
  } = props

  return (
    <Root className={cn({ selected })} onClick={onClick} data-testid={testId}>
      <LabelWrapper>
        <AbsoluteBlock
          direction="horizontal"
          horizontalAlign="center"
          aria-hidden
        >
          <Group direction="horizontal" verticalAlign="center" gap={8}>
            <Icon size="M" />
            <BodyText
              variant="medium"
              weight={selected ? 'bold' : 'normal'}
              wrap="no-wrap"
            >
              {label} · {count}
            </BodyText>
          </Group>
        </AbsoluteBlock>
        <PlaceHolderGroup direction="horizontal" horizontalAlign="center">
          <Icon size="M" />
          <BodyText variant="medium" weight="bold" wrap="no-wrap">
            {label} · {count}
          </BodyText>
        </PlaceHolderGroup>
      </LabelWrapper>
    </Root>
  )
}

export default TripItemFilter
